// Kho chứa bản đã-lọc-sẵn của từng ảnh.
//
// Vì sao cần: drawCanvas() chạy lại mỗi lần con trỏ di chuyển khi người dùng kéo
// ảnh, trên canvas 1200×3000. Áp ctx.filter lại từ đầu mỗi khung hình sẽ giật
// rất nặng, nên ảnh đã lọc được dựng một lần rồi giữ lại; lúc kéo chỉ còn
// drawImage một bitmap có sẵn.
//
// Đây là kho cấp module (dùng chung cả trang) chứ không nằm trong component —
// nhờ vậy component vẽ và component quản lý ảnh không phải chuyền ref cho nhau.

import { renderFilteredBitmap } from "./canvasEffects";

// key: `${photoId}:${filterId}` -> canvas đã lọc
const cache = new Map();

export const getFilteredBitmap = (photo, filter) => {
    // Hiệu ứng "Gốc" không đổi gì trên ảnh, dùng thẳng ảnh gốc, khỏi tốn bộ nhớ.
    if (!filter.css || filter.css === "none") return photo.img;

    const key = `${photo.id}:${filter.id}`;

    let bitmap = cache.get(key);
    if (!bitmap) {
        bitmap = renderFilteredBitmap(photo.img, filter);
        cache.set(key, bitmap);
    }
    return bitmap;
};

// Bỏ mọi bản đã lọc của một tấm ảnh (khi người dùng chụp lại tấm đó).
export const dropPhotoFromCache = photoId => {
    cache.forEach((_, key) => {
        if (key.startsWith(`${photoId}:`)) cache.delete(key);
    });
};

// Giữ cache gọn: bỏ bản đã lọc của những hiệu ứng không còn được chọn.
export const keepOnlyFilter = filterId => {
    cache.forEach((_, key) => {
        if (!key.endsWith(`:${filterId}`)) cache.delete(key);
    });
};

export const clearFilterCache = () => cache.clear();
